module.exports = __webpack_public_path__ + "static/media/placas (1).7372fa62.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/fotos/Placas/placas (1).jpg
// module id = 351
// module chunks = 0